import useSWR from "swr";

const useData = (key, fetcher) => {
    const { data, error, isLoading, mutate } = useSWR(key, fetcher);
    return { data, error, isLoading, mutate };
};

export default useData;
